import { inject, provide } from "vue";

export const ACTION_BAR_KEY = Symbol("action-bar");

export function provideActionBar(context) {
  provide(ACTION_BAR_KEY, context);
}

export function useActionBar() {
  const context = inject(ACTION_BAR_KEY, null);

  if (!context) {
    throw new Error("useActionBar must be used within <ActionBar>.");
  }

  return context;
}
